import { successNotifyService, failureNotifyService } from '@/services/errors.service.js';
import { isInteger } from 'core-js/fn/number';
import { isBoolean } from 'lodash';

export function checkInputFieldService(localData, action) {
    let cfObj = {};

    //////////////////////////////////////
    /// Users Collection
    //////////////////////////////////////

    if (action === "saveEQDegreeCertification" && localData.degreeCertification) {
        cfObj.fieldName = 'degreeCertification';
        cfObj.fieldValueIsNull = false;
        cfObj.collectionName = 'educationalQualification';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === "saveEQOrganization" && localData.organization) {
        cfObj.fieldName = 'organization';
        cfObj.fieldValueIsNull = false;
        cfObj.collectionName = 'educationalQualification';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === "saveEQGrade" && localData.grade) {
        cfObj.fieldName = 'grade';
        cfObj.fieldValueIsNull = false;
        cfObj.collectionName = 'educationalQualification';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === "saveEQStartDate" && localData.startDate) {
        cfObj.fieldName = 'startDate';
        cfObj.fieldValueIsNull = false;
        cfObj.collectionName = 'educationalQualification';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === "saveEQEndDate" && localData.endDate) {
        cfObj.fieldName = 'endDate';
        cfObj.fieldValueIsNull = false;
        cfObj.collectionName = 'educationalQualification';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === "saveEQCurrentlyActive") {
        cfObj.fieldName = 'currentlyActive';
        cfObj.fieldValueIsNull = false; // Can be null (faked)
        cfObj.collectionName = 'educationalQualification';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === "saveEQCountry" && localData.country) {
        cfObj.fieldName = 'country';
        cfObj.fieldValueIsNull = false;
        cfObj.collectionName = 'educationalQualification';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === 'saveEQCity' && localData.city) {
        cfObj.fieldName = 'city';
        cfObj.fieldValueIsNull = false;
        cfObj.collectionName = 'educationalQualification';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === 'saveEQDescription') {
        cfObj.fieldName = 'description';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'educationalQualification';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } /*else if (action === 'saveShoweducationalQualificationOnMap') {
        cfObj.fieldName = 'showExperienceOnMap';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'educationalQualification';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    }*/ else {
        cfObj.fieldName = null;
        cfObj.fieldValueIsNull = true;
        cfObj.collectionName = null;
        cfObj.vuexServiceName = null;
        return cfObj;
    }

}

export function saveInputFieldService(payload) {

    const isUserLoggedIn = payload.isUserLoggedIn;
    const action = payload.action;
    const currentThis = payload.currentThis;
    const localData = payload.localData;
    const educationalQualificationId = payload.educationalQualificationId;

    const cfObj = checkInputFieldService(localData, action);
    
    //// console.log(cfObj, payload);

    if (!isUserLoggedIn || cfObj.fieldValueIsNull) {
        return;
    }

    currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", true);

    //// console.log("executing...", localData);

    const fieldName = cfObj.fieldName;
    const vuexServiceName = cfObj.vuexServiceName;

    const dataObj = {};
    dataObj["_id"] = educationalQualificationId;
    dataObj['collectionName'] = cfObj.collectionName;

    if (localData[`${fieldName}`]) { // If field value is not null
        
        if(isInteger(localData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = Number(localData[`${fieldName}`].toString().trim());
        } if(isBoolean(localData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = Boolean(localData[`${fieldName}`].toString().trim());
        } else if(typeof localData[`${fieldName}`] === 'object') {
            dataObj[`${fieldName}`] = localData[`${fieldName}`]
        } else {
            dataObj[`${fieldName}`] = localData[`${fieldName}`].trim();
        }

    } else dataObj[`${fieldName}`] = null; // If field value is null

    // // console.log(dataObj);

    currentThis.$store
        .dispatch(`${vuexServiceName}/${action}`, dataObj)
        .then((res) => {
            currentThis.$store.commit(
                "editor/TOGGLE_SAVE_IN_PROGRESS",
                false
            );
            //// console.log(res);
        })
        .catch((err) => {
            throw err;
        });
}

export function deleteDocumentService(payload) {
    const currentThis = payload.currentThis;
    const educationalQualificationId = payload.educationalQualificationId;

    currentThis.$store.dispatch('editor/deleteEducationalQualification', educationalQualificationId).then((res) => {
        successNotifyService({currentThis, title: 'Educational Qualification Deleted', text: 'This Educational Qualification has been successfully deleted.'})
    }).catch(err => {
        throw err;
    });
}